export enum DepositPaymentTypeOfTransferEnum {
  CardAccountSettlement = 'CardAccountSettlement',
  OtherBankTransfer = 'OtherBankTransfer',
  OwnInsigniaAccount = 'OwnInsigniaAccount',
  OtherInsigniaAccount = 'OtherInsigniaAccount',
  BetweenInsigniaAccount = 'BetweenInsigniaAccount',
  Charge = 'Charge',
  Allocation = 'Allocation',
}
